<template>
  <div class="card card-equal-height">
    <header class="card-header">
      <p class="card-header-icon">
        <span class="icon">
          <font-awesome-icon icon="at" size="2x" v-if="training.fields.isELearning"></font-awesome-icon>
          <font-awesome-icon icon="users" size="2x" v-else></font-awesome-icon>
        </span>
      </p>
      <p class="card-header-title">
        <strong>{{ training.fields.title }}</strong>
      </p>
    </header>
    <div class="card-content">
      <div class="content">
        <p>{{ training.fields.topic }}</p>
        <markdown>{{ training.fields.shortDescription }}</markdown>
        <p v-if="!training.fields.isELearning">
          <strong>Képzés(ek) időpontja(i): </strong>{{ training.fields.dateString }}<br>
          <strong>Képzés(ek) helyszíne: </strong>{{ training.fields.location }} <br>
          <strong>Cím: </strong>{{ training.fields.address }}
        </p>
      </div>
    </div>
    <footer class="card-footer">
      <div class="card-footer-item" v-if="training.fields.isFull">
        <span class="tag is-danger is-medium">Megtelt</span>
      </div>
      <div class="card-footer-item" v-else>
        <router-link :to="{ name: 'view-training', params: { trainingId: training.sys.id } }" class="button is-primary is-fullwidth">
          Megtekintés &nbsp;
          <font-awesome-icon icon="arrow-alt-circle-right"></font-awesome-icon>
        </router-link>        </div>
    </footer>
  </div>
</template>

<script>
  export default {
    props: [
      'training'
    ]
  }
</script>

<style scoped>
  .card-header-icon {
    cursor: default;
  }
  .card-equal-height {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .card-equal-height .card-footer {
    margin-top: auto;
  }

  .tag {
    height: 38px;
  }
</style>



// WEBPACK FOOTER //
// src/components/General/TrainingSummaryCard.vue